//#region import libraries
// react
import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';

// custom components
import { Title, NewScreen } from "_atoms";

// bootstrap
import { Row, Col } from 'react-bootstrap';

// icons
import { BsChevronRight } from "react-icons/bs";
import { CgProfile } from "react-icons/cg";
import { MdEmail, MdNotifications } from "react-icons/md";
import { RiAdminLine } from "react-icons/ri";

// images
import PRM from "_assets/images/profile/AIRPORT.png";

// redux
import { selectUserDb } from '_redux/slices/main-screen/user';
import { useDispatch, useSelector } from 'react-redux';

// styling
import { Colors } from '_styles';
import { getAirportImage, selectAirportImage } from '_redux/slices/analytics/reviews';
//#endregion

const Account = () => {
    const imageStyle = { borderRadius: 10, marginRight: 80, boxShadow: "2px 4px 8px 2px #9E9E9E" }

    //#region redux
    const dispatch = useDispatch()
    const userDb = useSelector(selectUserDb);
    const airportImage = useSelector(selectAirportImage)
    //#endregion
    useEffect(() => {
        if (userDb && userDb.details.authority !== "ALL" && !airportImage) {
            const iata = userDb.details.authority
            dispatch(getAirportImage(iata))

        }
    }, [])

    // navigation
    const history = useHistory();

    // row item from list
    const RowItem = (props) => {
        const [hover, setHover] = useState(false);
        return (
            <div style={{ display: 'flex', cursor: 'pointer', height: 40, justifyContent: 'space-between', width: '110%', marginTop: 20 }} onMouseOver={() => { setHover(true) }} onMouseLeave={() => { setHover(false) }} onClick={() => { history.push(props.screen) }}>

                {/* Icon */}
                <div style={{ display: 'flex' }}>
                    {props.icon}
                    <p style={{ fontSize: 26, fontWeight: '200', color: Colors.TEXT_COLOR, marginLeft: 12 }}>{props.text}</p>
                </div>

                <BsChevronRight size={18} color={hover ? Colors.PRM_LIGHT_BLUE : 'grey'} style={{ cursor: 'pointer', marginTop: 12 }} onMouseOver={() => { setHover(true) }} onMouseLeave={() => { setHover(false) }} />
            </div>
        )
    }


    return (
        <NewScreen>

            <Row>
                <Col>
                    {/* Title */}
                    <Title name="Account" subtitle={"Account Settings"} description={"Edit your account information or contact us"} />
                </Col>
            </Row>


            <Row className='mt-5'>

                <Col xs={3}>
                    <Row>
                        <Col style={{ paddingTop: 0 }}>

                            {/*
                                userDb && userDb != null && userDb != undefined && userDb.role && userDb.role != undefined && userDb.details.authority !== "ALL" && (userDb.role == 'GARETH' || userDb.role == 'ADMIN') ?
                                    <RowItem text={"Admin Panel"} screen={"admin-panel"} icon={<RiAdminLine size={30} color={Colors.PRM_LIGHT_BLUE} style={{ cursor: 'pointer', marginTop: 5 }} />} />
                                    :
                                    null
                            */}
                    
                            
                            {
                                userDb && userDb != null && userDb != undefined && userDb.role && userDb.role != undefined && userDb.details.authority !== "ALL" && (userDb.role == 'GARETH' || userDb.role == 'ADMIN') ?
                                    <div style={{ 'paddingTop': 40 }}>
                                        <RowItem text={"Staff Management"} screen={"staff-management"} icon={<RiAdminLine size={30} color={Colors.PRM_LIGHT_BLUE} style={{ cursor: 'pointer', marginTop: 5 }} />} />
                                    </div>
                                    :
                                    null
                            }
                            <div style={{ 'paddingTop': 40 }}>
                                <RowItem text={"Account info"} screen={"edit-account"} icon={<CgProfile size={30} color={Colors.PRM_LIGHT_BLUE} style={{ cursor: 'pointer', marginTop: 5 }} />} />
                            </div>

                            <div style={{ 'paddingTop': 40 }}>
                                <RowItem text={"Contact us"} screen={"contact-us"} icon={<MdEmail size={30} color={Colors.PRM_LIGHT_BLUE} style={{ cursor: 'pointer', marginTop: 5 }} />} />
                            </div>
                            <div style={{ 'paddingTop': 40 }}>
                                <RowItem text={"Updates"} screen={"notifications"} icon={<MdNotifications size={30} color={Colors.PRM_LIGHT_BLUE} style={{ cursor: 'pointer', marginTop: 5 }} />} />
                            </div>

                        </Col>
                    </Row>
                </Col>

                {/* Image */}
                <Col>
                    <div style={{ paddingLeft: 100, paddingRight: 100, marginTop: -50 }}>
                        {
                            (userDb && airportImage) ?
                                <img src={airportImage} width={'100%'} style={imageStyle} />
                                :

                                <img src={PRM} width={'100%'} style={imageStyle} />
                        }
                    </div>
                </Col>
                {/* <Col>
                    <div style={{ paddingLeft: 100, paddingRight: 100, marginTop: -50 }}>
                        {
                            (userDb && userDb.details.authority == 'DUB') ?
                                <img src={DUB} width={'100%'} style={imageStyle} />
                                :
                                (userDb && userDb.details.authority == 'ORK') ?
                                    <img src={ORK} width={'100%'} style={imageStyle} />
                                    :
                                    (userDb && userDb.details.authority == 'BRS') ?
                                        <img src={BRS} width={'100%'} style={imageStyle} />
                                        :
                                        <img src={PRM} width={'100%'} style={imageStyle} />
                        }
                    </div>
                </Col> */}
            </Row>
        </NewScreen>
    );
}

export default Account;